import { State } from "../state";
import { Request } from "@/network/request";
// import Swal from "sweetalert2";
export default class skilles {
  tableData = {
    data: [],
    headers: {
      id: {
        name: "id",
        keys: ["id"],
      },
      name: {
        name: "name",
        keys: ["name"],
      },
      description: {
        name: "description",
        keys: ["description"],
      },
    },
    meta: {
      total: 1,
      per_page: 1,
      current_page: 1,
    },
  };

  getSkillesState = new State();
  postSkillesState = new State();
  editSkillesState = new State();
  deleteSkillesState = new State();

  getSkilles(params) {
    let request = new Request({
      method: "get",
      endpoint: `/skill`,
      params: params,
      token: this.token,
    });

    this.getSkillesState.trigger(
      async () => {
        return await request.send();
      },
      {
        onSuccess: (value) => {
          this.tableData.data = value.skills;
          this.tableData.meta = value.meta;
        },
        onError: (error) => {
          console.log(error);
        },
      }
    );
  }
  postSkilles(payload) {
    let request = new Request({
      method: "post",
      endpoint: `/skill`,
      data: payload,
      token: this.token,
    });

    this.postSkillesState.trigger(
      async () => {
        return await request.send();
      },
      {
        onSuccess: (value) => {
          this.getSkilles();
        },
        onError: (error) => {
          console.log(error);
        },
      }
    );
  }
  editSkilles(payload, id) {
    let request = new Request({
      method: "put",
      endpoint: `/skill/${id}`,
      data: payload,
    });

    this.editSkillesState.trigger(
      async () => {
        return await request.send();
      },
      {
        onSuccess: (value) => {
          this.getSkilles();
        },
        onError: (error) => {
          console.log(error);
        },
      }
    );
  }
  deleteSkilles(id) {
    let request = new Request({
      method: "delete",
      endpoint: `/skill/${id}`,
    });

    this.deleteSkillesState.trigger(
      async () => {
        return await request.send();
      },
      {
        onSuccess: (value) => {
          this.getSkilles();
        },
        onError: (error) => {
          console.log(error);
        },
      }
    );
  }
}

export const Skilles = new skilles();
